module.exports = __webpack_public_path__ + "static/media/dental_product_four.cd2019bd.png";